import { hasValue } from "../../../utils/functions.js";

import DateField from "../../common/date-field";

export default {
  name: "MensalidadeIsencao",
  components: {
    DateField
  },
  data() {
    return {
      pageName: "Isenções de Mensalidade",
      situacoes: ["Vigente", "Futura", "Encerrada"],
      itemList: [],
      loadingList: false,
      countFilter: 0,
      filter: {
        IdMerchant: null,
        Nome: null,
        Documento: null,
        Situacao: null
      },
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },

      loadingMerchant: false,
      loadingAdd: false,
      merchantSearch: null,
      merchant: null,
      novaIsencao: {
        DataInicioIsencao: null,
        DataLimiteIsencao: null,
        PrazoIndeterminado: true,
        Motivo: null
      },

      loadingEncerrar: false,
      isencaoSelecionada: null,
      encerramento: {
        DataLimiteIsencao: null,
        MotivoEncerramento: null
      },

      loadingEditar: false,
      edicao: {
        Id: null,
        DataLimiteIsencao: null,
        PrazoIndeterminado: false,
        Motivo: null
      }
    };
  },

  watch: {
    "pagination.PageNumber"() {
      this.ListIsencoes();
    },
    "pagination.RowsPerPage"() {
      this.pagination.PageNumber = 1;
      this.ListIsencoes();
    }
  },

  mounted() {
    this.ListIsencoes();
  },

  methods: {
    hasValue(item) {
      return hasValue(item);
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.pagination.PageNumber = 1;
      this.ListIsencoes();
    },

    ResetFilter() {
      this.filter = {
        IdMerchant: null,
        Nome: null,
        Documento: null,
        Situacao: null
      };
      this.pagination.PageNumber = 1;
      this.ListIsencoes();
    },

    ListIsencoes() {
      this.loadingList = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => {
        if (hasValue(value)) this.countFilter++;
      });

      const params = {
        PageNumber: this.pagination.PageNumber,
        RowsPerPage: this.pagination.RowsPerPage,
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Merchant.Name": this.filter.Nome,
        "Object.Merchant.Identity": this.filter.Documento,
        "Object.Situacao": this.filter.Situacao
      };

      this.$store
        .dispatch("ListMensalidadeIsencao", params)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar as isenções. Tente novamente.", "danger", "Erro ao listar.", error);
        })
        .finally(() => (this.loadingList = false));
    },

    OpenModalAdd() {
      this.merchantSearch = null;
      this.merchant = null;
      this.novaIsencao = {
        DataInicioIsencao: new Date().toISOString(),
        DataLimiteIsencao: null,
        PrazoIndeterminado: true,
        Motivo: null
      };
      this.$bvModal.show("mFormIsencao");
    },

    BuscarMerchant() {
      if (!hasValue(this.merchantSearch)) {
        this.$makeToast("Informe o código ou o documento do merchant.", "warning", "Busca de merchant");
        return;
      }

      this.loadingMerchant = true;
      this.merchant = null;

      const termo = this.merchantSearch.replace(/\D/g, "");
      const params = termo.length >= 11 ? { documento: termo } : { idMerchant: termo };

      this.$store
        .dispatch("ObterMerchantMensalidadeIsencao", params)
        .then(response => {
          this.merchant = response;
        })
        .catch(error => {
          this.$makeToast("Merchant não elegível para isenção.", "danger", "Merchant não elegível.", error);
        })
        .finally(() => (this.loadingMerchant = false));
    },

    AddIsencao() {
      if (this.merchant == null) {
        this.$makeToast("Busque e selecione um merchant elegível antes de adicionar.", "warning", "Nova isenção");
        return;
      }

      if (!hasValue(this.novaIsencao.Motivo)) {
        this.$makeToast("Informe o motivo da isenção.", "warning", "Nova isenção");
        return;
      }

      if (!this.novaIsencao.PrazoIndeterminado && !hasValue(this.novaIsencao.DataLimiteIsencao)) {
        this.$makeToast("Informe a competência final ou marque a isenção como prazo indeterminado.", "warning", "Nova isenção");
        return;
      }

      this.loadingAdd = true;

      const payload = {
        Merchant: { Id: this.merchant.Id },
        DataInicioIsencao: this.novaIsencao.DataInicioIsencao,
        DataLimiteIsencao: this.novaIsencao.PrazoIndeterminado ? null : this.novaIsencao.DataLimiteIsencao,
        PrazoIndeterminado: this.novaIsencao.PrazoIndeterminado,
        Motivo: this.novaIsencao.Motivo
      };

      this.$store
        .dispatch("AddMensalidadeIsencao", payload)
        .then(() => {
          this.$makeToast("Isenção incluída com sucesso.", "success", "Nova isenção");
          this.$bvModal.hide("mFormIsencao");
          this.ListIsencoes();
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao incluir a isenção.", "danger", "Erro ao incluir.", error);
        })
        .finally(() => (this.loadingAdd = false));
    },

    OpenModalEditar(isencao) {
      this.isencaoSelecionada = isencao;
      this.edicao = {
        Id: isencao.Id,
        DataLimiteIsencao: isencao.PrazoIndeterminado ? null : isencao.DataLimiteIsencao,
        PrazoIndeterminado: isencao.PrazoIndeterminado,
        Motivo: isencao.Motivo
      };
      this.$bvModal.show("mEditarIsencao");
    },

    EditarIsencao() {
      if (!hasValue(this.edicao.Motivo)) {
        this.$makeToast("Informe o motivo da isenção.", "warning", "Editar isenção");
        return;
      }

      if (!this.edicao.PrazoIndeterminado && !hasValue(this.edicao.DataLimiteIsencao)) {
        this.$makeToast("Informe a competência final ou marque a isenção como prazo indeterminado.", "warning", "Editar isenção");
        return;
      }

      this.loadingEditar = true;

      const payload = {
        Id: this.edicao.Id,
        DataLimiteIsencao: this.edicao.PrazoIndeterminado ? null : this.edicao.DataLimiteIsencao,
        PrazoIndeterminado: this.edicao.PrazoIndeterminado,
        Motivo: this.edicao.Motivo
      };

      this.$store
        .dispatch("UpdateMensalidadeIsencao", payload)
        .then(() => {
          this.$makeToast("Isenção atualizada com sucesso.", "success", "Editar isenção");
          this.$bvModal.hide("mEditarIsencao");
          this.ListIsencoes();
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao atualizar a isenção.", "danger", "Erro ao atualizar.", error);
        })
        .finally(() => (this.loadingEditar = false));
    },

    OpenModalEncerrar(isencao) {
      this.isencaoSelecionada = isencao;
      this.encerramento = {
        DataLimiteIsencao: new Date().toISOString(),
        MotivoEncerramento: null
      };
      this.$bvModal.show("mEncerrarIsencao");
    },

    EncerrarIsencao() {
      if (!hasValue(this.encerramento.MotivoEncerramento)) {
        this.$makeToast("Informe o motivo do encerramento.", "warning", "Encerrar isenção");
        return;
      }

      this.loadingEncerrar = true;

      const payload = {
        Id: this.isencaoSelecionada.Id,
        DataLimiteIsencao: this.encerramento.DataLimiteIsencao,
        MotivoEncerramento: this.encerramento.MotivoEncerramento
      };

      this.$store
        .dispatch("EncerrarMensalidadeIsencao", payload)
        .then(() => {
          this.$makeToast("Isenção encerrada com sucesso.", "success", "Encerrar isenção");
          this.$bvModal.hide("mEncerrarIsencao");
          this.ListIsencoes();
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao encerrar a isenção.", "danger", "Erro ao encerrar.", error);
        })
        .finally(() => (this.loadingEncerrar = false));
    },

    OpenModalDetalhes(isencao) {
      this.isencaoSelecionada = isencao;
      this.$bvModal.show("mDetalhesIsencao");
    },

    SituacaoBadge(situacao) {
      switch (situacao) {
        case "Vigente":
          return "badge badge-success";
        case "Futura":
          return "badge badge-info";
        default:
          return "badge badge-secondary";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/MensalidadeIsencao/MensalidadeIsencao.js